import { IconProps } from "./IconProps";
import { svgIconProps } from "./svgIconProps";

export function IconInfo(props: IconProps) {
  return (
    <svg {...svgIconProps(props)}>
      <path d="M14 18.167c0 .22-.09.433-.251.589a.87.87 0 0 1-.606.244 2.03 2.03 0 0 1-1.414-.57 1.918 1.918 0 0 1-.586-1.374V11.5a.274.274 0 0 0-.084-.196.29.29 0 0 0-.202-.082.87.87 0 0 1-.606-.244.821.821 0 0 1-.251-.59c0-.22.09-.432.251-.588a.87.87 0 0 1 .606-.244c.53 0 1.04.204 1.414.57.375.364.586.858.586 1.374v5.556c0 .073.03.144.084.196a.29.29 0 0 0 .202.081.87.87 0 0 1 .606.244c.16.157.251.369.251.59Zm-2.571-11.39c.282 0 .558-.08.793-.233.235-.153.418-.37.526-.624.109-.253.137-.533.082-.802a1.377 1.377 0 0 0-.391-.711 1.442 1.442 0 0 0-.732-.38 1.467 1.467 0 0 0-.825.079 1.42 1.42 0 0 0-.641.511 1.361 1.361 0 0 0 .177 1.754c.268.26.632.407 1.01.407Z" />
    </svg>
  );
}
